var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74B8E5"
    },
    d: "M469.599,370.112H42.401C19.021,370.112,0,351.091,0,327.711V184.288 c0-23.38,19.021-42.401,42.401-42.401h427.198c23.38,0,42.401,19.021,42.401,42.401v143.425 C512,351.091,492.979,370.112,469.599,370.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#39A3DB"
    },
    d: "M469.599,141.887H256v228.226h213.599c23.38,0,42.401-19.021,42.401-42.401V184.288 C512,160.908,492.979,141.887,469.599,141.887z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE49C"
    },
    cx: 146.525,
    cy: 256.003,
    r: 30.432
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE49C"
    },
    cx: 255.846,
    cy: 256.003,
    r: 30.432
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F59D00"
    },
    d: "M405.609,274.171H346.86c-10.036,0-18.172-8.136-18.172-18.172c0-10.036,8.136-18.172,18.172-18.172 h58.749c10.036,0,18.172,8.136,18.172,18.172C423.781,266.035,415.645,274.171,405.609,274.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC72D"
    },
    d: "M256,225.568v60.864c16.741-0.081,30.287-13.672,30.287-30.433S272.74,225.648,256,225.568z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessCode);
export default __webpack_public_path__ + "static/media/access_code.bf25b267e2f2c34a2d9604f7786eb65f.svg";
export { ForwardRef as ReactComponent };